import { render, staticRenderFns } from "./OrganizationGeneral.vue?vue&type=template&id=35c76748&"
import script from "./OrganizationGeneral.vue?vue&type=script&lang=js&"
export * from "./OrganizationGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports